// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as ServiceIcons from './Icons';

import * as coreSelectors from '../core/selectors';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import * as accountSelectors from '../account/selectors';

import * as MessageFormat from './MessageFormat';
import * as coreActions from '../core/actions';
import DataTable from 'ui/DataTable';
import ActivityLayout from 'ui/ActivityLayout';
import { ACTIVITY_MESSAGE_TYPES, ACTIVITY_OPERATIONS, ACTIVITY_PAGES, ACTIVITY_VIEW_TYPES, CHAT_ACTIVITY_TYPES, GENERAL_FILTER_TYPES } from 'constants/activity.constants';
import FilterDialog from './FilterDialog';
import { getDistictFilteredAccounts } from 'utils';

const styles = theme => ({
  /* Message list container */
  messageList : {
    marginTop: 10,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  
});


/*
 * Activity list
 */

class ChatActivity extends Component {

  constructor(props) {
    super(props);
    this.dataTableRef = React.createRef();
  }

  state = {
    scrollDisplay: 'flex',
    verifyUnread : false,
    verifyMessage : {},
    menuMessage : {},
    menuOpen : false,
    menuElement : null,
    verifyDuplicateContact : false,
    duplicateContactNumber : '',
    duplicateContactName : '',
    blockNumberDetailsMapping: {
      "OC": "outcallNumber",
      "VM": "ani",
      "IC": "ani"
    },
    tabSelected: 0,
    mouseState: 'left',
    mouseStatePdf: 'left',
    selectedMessages: [],
    selectedChatMessages: [],
    requestType: 'SELECT',
    companyFilterType: GENERAL_FILTER_TYPES.ALL,
    userFilterType: GENERAL_FILTER_TYPES.ALL,
    rememberFiltersChecked: false,
    rememberFiltersUpdated: false,
    loadedAtHeight: 0,
    loadedAll: false,
    hostsOnTest: ['dev', 'test', 'beta'],
    matchWord:false,
    showPdfExportOptions:false,
  }


  componentDidMount() {
    if (!this.props.dashboard) {
      document.title = 'Ruby - Chat Activity';
    }
    // Fetch initial pure chats if we don't have any yet
    if(!((this.props?.last20Messages?.pureChats ?? []).length > 0)){
      this.load();
    }
    this.updateActivityViewType();
  }
  updateActivityViewType(prevProps){
    if(!prevProps || (prevProps && prevProps.dashboard !== this.props.dashboard) ){
        this.props.setActivityViewType(ACTIVITY_VIEW_TYPES.ALL)
    }
  }
  // Helper method to validate dates
  isValidDate(date) {
    if (!date) return false;
    
    if (date instanceof Date) {
      return !isNaN(date.getTime());
    }
    return false;
  }

  // Helper method to check if two dates have the same day/month/year
  isSameDate(date1, date2) {
    if (!this.isValidDate(date1) || !this.isValidDate(date2)) return false;
    
    return date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate();
  }
  // Helper method to check if date1 is before or equal to date2 (comparing only date portion)
  isDateBeforeOrEqual(date1, date2) {
    if (!this.isValidDate(date1) || !this.isValidDate(date2)) return false;
    
    // Create new dates at midnight to compare only date portions
    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    
    return d1 <= d2;
  }

  componentDidUpdate(prevProps, prevState){
    this.updateActivityViewType(prevProps)
      if(!this.isSameDate(this.props.startTime, prevProps.startTime) || !this.isSameDate(this.props.endTime, prevProps.endTime)){
        // console.log("in component did update the dates have been changed")
        // Make sure start date is on or before end date
        if(!this.isDateBeforeOrEqual(this.props.startTIme, this.props.endTime)){
          // Fetch new records
          this.load();
        }
      }
  }
  load = () => {
    this.props.getPureChats({
      force: true,
      chatVersion: 0,
      completed: (result) => {
        // console.log("Load result", result?.pageNumber, result?.totalChatPages)
        if (result?.pageNumber >= result?.totalChatPages &&  !this.state.loadedAll) {
          this.setState({ loadedAll: true });
        } else if(this.state.loadedAll) {
          this.setState({ loadedAll: false })
        }
      }
    });
  }
  loadMore = () => {
    this.props.getPureChats({
      force: true,
      scrollEnd: true,
      chatVersion:0,
      completed: (result) => {
        // console.log("Load More result", result?.pageNumber, result?.totalChatPages)
        if (result?.pageNumber >= result?.totalChatPages && !this.state.loadedAll) {
          this.setState({ loadedAll: true });
        }
      },
    });
  }

  toggleRead = (message) => {
    if(message.messageType === ACTIVITY_MESSAGE_TYPES.SMS && message.messageRead){
      this.setState({verifyUnread: true, verifyMessage: message});
    } else if (!message.read) {
      if(message.messageType !== ACTIVITY_MESSAGE_TYPES.CHAT){
        this.props.markMessageRead(message.messageId);
      } else {
        this.props.markPurechatRead(message.chatId, 'N');
      }
    } else {
      this.setState({verifyUnread: true, verifyMessage: message});
    }
  }

  markUnread = (message) => {
    this.setState({verifyUnread: false});
    if(this.state.verifyMessage.messageType === ACTIVITY_MESSAGE_TYPES.CHAT){
      this.props.markPurechatRead(this.state.verifyMessage.chatId, 'Y');
      return;
    }
    this.props.unmarkMessageRead(this.state.verifyMessage.messageId);
  }

  /* Search a text field for a keyword */
  searchField(field, search) {
    if (typeof(field) !== 'string') {
      return(false);
    }
    if (typeof(search) !== 'string' || search.length === 0) {
      return(false);
    }
    return(field.toUpperCase().includes(search));
  }

  getMessageId = (message)=> message.chatId

  generateCSVReport = () => {
    let minDate = new Date(this.props.startTime);
    let maxDate = new Date(this.props.endTime);
      minDate.setHours(0,0,0,0)
      maxDate.setHours(24,0,0,0)
    if(Math.floor((maxDate - minDate) / (1000*60*60*24)) >31){
      this.props.postSnackMessage('error', '','CSV export can only load max of 31 days');
      return;
    }
    this.props.generateCSV(this.props.filterType, null, minDate, maxDate, (this.props.filterSearch || '').trim().toUpperCase(), (this.state.selectedMessages || []).join(','), ACTIVITY_PAGES.CHAT_ACTIVITY);
  }

  bulkOperationSelected = (operation) => {
    if(operation === ACTIVITY_OPERATIONS.UNREAD){ this.props.bulkUnmarkMessageRead(undefined, this.state.selectedChatMessages) }
    if(operation === ACTIVITY_OPERATIONS.READ){ this.props.bulkMarkMessageRead(undefined, this.state.selectedChatMessages) }
    if(operation === ACTIVITY_OPERATIONS.FLAG){ this.props.toggleBulkFollowup(undefined, this.state.selectedChatMessages, this.props.dashboard, 'Y') }
    if(operation === ACTIVITY_OPERATIONS.UNFLAG){ this.props.toggleBulkFollowup(undefined, this.state.selectedChatMessages, this.props.dashboard, 'N') }
    if(operation === ACTIVITY_OPERATIONS.ARCHIVE){ this.props.bulkArchiveMessage(undefined, this.state.selectedChatMessages) }
    if(operation === ACTIVITY_OPERATIONS.UNARCHIVE){ this.props.bulkUnarchiveMessage(undefined, this.state.selectedChatMessages) }
    this.dataTableRef?.current?.resetSelection()
  }

  getMessages(){
    const {
      filters, 
      filterDays, filterSearch,
      activityViewType, last20Messages } = this.props;


const { companyFilterType } = this.state;
    /* The dashboard view passes this as true for the minimal view */
    let dashboard = Boolean(this.props.dashboard);
    /* See if any of the filters are set or we don't filter at all */
    let filtersSet = false;
    Object.keys(filters).forEach(filterKey => {
      if (filters[filterKey].active) {
        filtersSet = true;
      }
    });
    let searchText = filterSearch.trim().toUpperCase();
    /* Remove common formatting characters from the search string
       for matching phone number fields */
    let phoneSearchText = searchText.replace(/[()-\s]/g, '');
    // Create an inital list of only chat messages
    let messageList = last20Messages?.pureChats ?? []
    //  On the main view filter by company filter types
    if(!dashboard && companyFilterType !== GENERAL_FILTER_TYPES.ALL){
      messageList = messageList?.filter(message => message.accountId === companyFilterType) || [];
    }
    let messagesFiltered = messageList.filter(message => {
      /* Always keep messages with hold set.  This is set when
         changing the read, archive or followup status but we don't want it
         to immediately vanish if the current filter removes it.  They
         need to click query or change the filter settings to remove the
         holds */
      // if (message.hold) {
      //   return(true);
      // }
      // Filter out the dashboard messages here
      if(dashboard){
        //  No Archived messages on dashboard page
        if(message.archived || message.messageArchived){
          return false
        }
        // default fallback
        else{
          return true
        }
      }
      // Filter out activity for the main chat activity view
      // 1. Filter out for archived tab
      if(activityViewType === ACTIVITY_VIEW_TYPES.ARCHIVED && !(message.messageArchived || message.archived)){
          return false
      }
      //  Remove Archived messages from all chat activity tab
      if(activityViewType !== ACTIVITY_VIEW_TYPES.ARCHIVED && (message.messageArchived || message.archived)){
        return false
      }
      
      /* 2. No go through all the specific exclusive filters if any are set */
      if (filtersSet) {
        let match = false;
        if (filters.actionableSupport.active && message?.types === CHAT_ACTIVITY_TYPES.A_SUPPORT) {
          match = true;
        }
        if (filters.nonActionableSupport.active && message?.types === CHAT_ACTIVITY_TYPES.NON_A_SUPPORT) {
            match = true;
        }
        if (filters.leads.active && message?.types === CHAT_ACTIVITY_TYPES.LEAD) {
          match = true;
        }
        if(filters.spam.active && message?.types === CHAT_ACTIVITY_TYPES.SPAM){
            match = true;
        }
        if (filters.flagged.active && message.followup === 'Y') {
          match = true;
        }
        if (filters.unread.active && !(message.read || message.messageRead)){
            match = true;
        }
        if (!match) {
          return(false);
        }
      }
      
      /* 3. Filter out by search string if set */
      if (searchText.length > 0) {
        
        /* Text content */
        if (this.searchField(message.textContent, searchText)) {
          return(true);
        }
        
        /* Form content only search the values */
        if (message.formContent) {
          let formContent = JSON.parse(message.formContent);
          for (let i=0; i< formContent.fields.length; i++) {
            if (this.searchField(formContent.fields[i].value, searchText)) {
              return(true);
            }
          }
        }
        
        /* Recording Transcription */
        if (this.searchField(message.recordingTranscription, searchText)) {
          return(true);
        }
        
        /* User name that created task */
        if (this.searchField(message.taskUser, searchText)) {
          return(true);
        }
        
        /* Caller name */
        if (this.searchField(message.caller, searchText)) {
          return(true);
        }
        
        /* ANI */
        if (this.searchField(message.ani, phoneSearchText)) {
          return(true);
        }
        
        /* DNIS */
        if (this.searchField(message.dnis, phoneSearchText)) {
          return(true);
        }
        
        /* Outcall number */
        if (this.searchField(message.outcallNumber, phoneSearchText)) {
          return(true);
        }
        
        /* Outcall source */
        if (this.searchField(message.outcallSourceNumber, phoneSearchText)) {
          return(true);
        }
        
        /* Request text */
        if (this.searchField(message.request, searchText)) {
          return(true);
        }

        if(this.searchField(MessageFormat.messageDetail(message,this.props.user), searchText)){
          return(true);
        }

        if(this.searchField(MessageFormat.getToDetails(message, this.props.user), searchText)){
          return(true);
        }
        
        /* No match */
        return(false);
      }
      // default fallback
      return(true);
    });
    if(filterDays !== null){
      let minDate = new Date(this.props.startTime);
      let maxDate = new Date(this.props.endTime);
      minDate.setHours(0,0,0,0);
      maxDate.setHours(24,0,0,0);

      messagesFiltered = messagesFiltered?.filter(message => (new Date(message?.taken).getTime() > minDate.getTime() && new Date(message?.taken).getTime() < maxDate.getTime()) ||
                                                            (new Date(message?.lastMessage).getTime() > minDate.getTime() && new Date(message?.lastMessage).getTime() < maxDate.getTime()));
      if(this.state.hostsOnTest.filter(item => window.location.host.includes(item)).length > 0){
        // console.log("loadedAll", this.state.loadedAll)
        // console.log("lastMessage", lastMessage);
      }
    }
    messagesFiltered.sort((a, b)  => (new Date(b.taskEndTime).getTime() - new Date(a.taskEndTime).getTime()))
    if(this.state.hostsOnTest.filter(item => window.location.host.includes(item)).length > 0){
      //console.log(messagesFiltered);
    }
    return messagesFiltered
  }
  render() {
    const { classes, user,
             filterListText, 
            openActivityDetail, toggleFollowup, markPurechatFollowup,
            activityViewType } = this.props;

    const userAccounts = getDistictFilteredAccounts(user, (role)=> role.chatServiceEnabled === 'Y')
    if(!(userAccounts.length > 0)){
        return (
            <MuiCore.Typography>You do not have access to view this page</MuiCore.Typography>
        )
    }

   const messagesFiltered = this.getMessages();
      const dashboardColumns = [
        {
          heading: "type",
          textAlign:'left',
          renderCell: (message) => {
            return (
              <div className={classes.messageIcon}>
              <MuiCore.Hidden>
                <MuiCore.IconButton
                  onClick={(event) => {
                    this.toggleRead(message)
                    event.stopPropagation();
                  }}
                  style={{color: (message.read || message.messageRead) ? '#D6D7DB' :  '#122457'}}>
                  {ServiceIcons.IconForType(message, user.userId, {color: (message.read || message.messageRead) ? '#D6D7DB' : '#122457'})}
                </MuiCore.IconButton> 
              </MuiCore.Hidden>
            </div>
            );
          },
        },
        {
          heading: "from",
          textAlign:'left',
          renderCell: (message) => {
            return (
                message.combinedDisplayName
                  ? message.combinedDisplayName
                  : `${MessageFormat.messageDetail(message, user)}`
            );
          },
        },
        {
          heading: "to",
          textAlign:'left',
          renderCell: (message) => {
            return (MessageFormat.getToDetails(message, user));
          },
        },
        {
            heading: "Tag",
            textAlign:'left',
            renderCell: (message) => {
              return message?.types ?? '-'
            },
          },
        {
          heading: "Date/Time",
          textAlign:'left',
          renderCell: (message) => {
            return (MessageFormat.formatDateTime(message)
            );
          },
        },
      ]
      const activityColumns = [
        dashboardColumns[0],
        dashboardColumns[1],
        dashboardColumns[2],
        {
          heading:'Company',
          textAlign:'left',
          renderCell: (message)=>{
            return(
                MessageFormat.getCompany(message,this.props.user)
            )
          }
        },
        {
          heading: "Outcome",
          textAlign:'left',
          renderCell: (message) => {
            return (message?.contactDescription || ""
            );
          },
        },
        dashboardColumns[3],
        dashboardColumns[4],
        {
            heading: "",
            textAlign:'right',
            renderCell: (message) => {
              let changeable = (message.deliveryId && message.userId === user.userId) || message.messageType === 'SMS' || message.messageType === 'CHAT';
              return (
                <>
                 {/* null, "Spam", "Testing", and "ProChats Use" types are NOT BILLABLE */}
                  {message &&
                    (!message?.types ||
                      (message?.types &&
                        message?.types !== CHAT_ACTIVITY_TYPES.SPAM &&
                        message?.types !== CHAT_ACTIVITY_TYPES.TESTING &&
                        message?.types !==
                          CHAT_ACTIVITY_TYPES.PROCHATS_USE)) && (
                      <MuiCore.Chip label="Billable" />
                    )}
                  <MuiCore.IconButton
                    color="primary"
                    disabled={!changeable}
                    onClick={(event) => {
                      if (message.messageType !== ACTIVITY_MESSAGE_TYPES.CHAT) {
                        toggleFollowup(message, this.props.dashboard);
                      } else {
                        if (message.followup === "Y") {
                          markPurechatFollowup(message.chatId, "N");
                        } else {
                          markPurechatFollowup(message.chatId, "Y");
                        }
                      }
                      event.stopPropagation();
                    }}
                  >
                    <ServiceIcons.FollowupIcon
                      followup={message.followup}
                      messageFollowup={message.messageFollowup}
                      style={{
                        color:
                          message.followup === "Y" ||
                          message.messageFollowup === "Y"
                            ? "#e5136c"
                            : changeable
                            ? "#000"
                            : "",
                      }}
                    />
                  </MuiCore.IconButton>
                </>
              );
            },
          },
      ];
      // console.log("selectedIds", this.state.selectedMessages)
    
      // console.log("TIMES", this.props.startTime, this.props.endTime)
    return (
      <React.Fragment>
        <FilterDialog
          type={ACTIVITY_PAGES.CHAT_ACTIVITY}
        />
        <ActivityLayout
          dashboard={this.props.dashboard}
          hideFilters={this.props.dashboard}
          isLoading={this.props.showLoading}
          userAccounts={userAccounts}
          page={ACTIVITY_PAGES.CHAT_ACTIVITY}
          popups={[
            {
              open: this.state.verifyUnread,
              title: "Reset To Unread",
              text: "Do you wish to clear the read date of this activity?",
              actions: [
                {
                  text: "Clear Read Date",
                  onClick: this.markUnread,
                },
                {
                  text: "Cancel",
                  onClick: () => this.setState({ verifyUnread: false }),
                },
              ],
              onClose: () => this.setState({ verifyUnread: false }),
            }
          ]}
          onCsvClick={this.generateCSVReport}
          csvDisabled={messagesFiltered.length === 0}
          renderFilters={{
            filterListText,
            onClick: () => this.props.setShowFilterDialog(true),
          }}
          filterKey="chat-"
          companyFilterType={this.state.companyFilterType}
          startTime={this.props.startTime}
          endTime={this.props.endTime}
          popupFilters={this.props.filters}
          onCompanyFilterChange={(value) => {
            this.setState({ companyFilterType: value });
          }}
          onStartTimeChange={(value) => {
            if(this.isValidDate(value)){
              this.props.setPureChatStartTime(value);
            } else {
              // Default of 30 days ago
              this.props.setPureChatStartTime(new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000));
            }
          }}
          onEndTimeChange={(value) => {
            if(this.isValidDate(value)){
              this.props.setPureChatEndTime(value);
            } else {
              // Default of today
              this.props.setPureChatEndTime(new Date());
            }
          }}
        >
          <div ref={this.containerRef} className={classes.messageList}>
            <DataTable
              enableNoContentPlaceholder
              ref={this.dataTableRef}
              getRowId={this.getMessageId}
              marginTop={0}
              onRowClick={(message) => {
                this.props.getBlockNumbersByAccount(message.accountId);
                openActivityDetail(message);
              }}
              onSelectionChange={(selectedIds, selectedData) => {
                if (!this.props.dashboard) {
                  this.setState({ selectedChatMessages: selectedIds });
                }
              }}
              onSelectComponent={() => {
                return (
                  <div>
                    <MuiCore.Select
                      variant="outlined"
                      placeholder="Select"
                      onChange={(event) => {
                        this.bulkOperationSelected(event.target.value);
                      }}
                      style={{ width: 150 }}
                      inputProps={{
                        style: { fontFamily: "Sofia", fontSize: 14 },
                      }}
                      renderValue={() => {
                        if (this.state.requestType === "SELECT") {
                          return "Select";
                        }
                      }}
                      value={this.state.requestType}
                    >
                      <MuiCore.MenuItem key="READ" value="READ">
                        Mark Read
                      </MuiCore.MenuItem>
                      <MuiCore.MenuItem key="UNREAD" value="UNREAD">
                        Mark Unread
                      </MuiCore.MenuItem>
                      <MuiCore.MenuItem key="FLAG" value="FLAG">
                        Flag
                      </MuiCore.MenuItem>
                      <MuiCore.MenuItem key="UNFLAG" value="UNFLAG">
                        Unflag
                      </MuiCore.MenuItem>
                      {activityViewType !== "archived" && (
                        <MuiCore.MenuItem key="ARCHIVE" value="ARCHIVE">
                          Archive
                        </MuiCore.MenuItem>
                      )}
                      {activityViewType === "archived" && (
                        <MuiCore.MenuItem key="UNARCHIVE" value="UNARCHIVE">
                          Unarchive
                        </MuiCore.MenuItem>
                      )}
                    </MuiCore.Select>
                  </div>
                );
              }}
              enableSelect={!this.props.dashboard}
              columns={
                this.props.dashboard ? dashboardColumns : activityColumns
              }
              data={messagesFiltered}
            />

            {messagesFiltered.length > 0 && !this.props.dashboard && (
              <MuiCore.Grid
                style={{ width: "100%", textAlign: "center", marginTop: 10 }}
              >
                <MuiCore.Typography
                  style={{ fontFamily: "Sofia", fontSize: 20 }}
                >
                  Showing 1 - {messagesFiltered.length}
                </MuiCore.Typography>
                {this.state.loadedAll ? (
                  <MuiCore.Typography
                    style={{ fontFamily: "Sofia", fontSize: 20 }}
                  >
                    Please change the start date to load more
                  </MuiCore.Typography>
                ) : (
                  <MuiCore.Button
                    onClick={() => this.loadMore()}
                    style={{ marginTop: 10 }}
                  >
                    Load More
                  </MuiCore.Button>
                )}
              </MuiCore.Grid>
            )}
          </div>
        </ActivityLayout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    // messages : serviceSelectors.getMessages(state),
    refreshing : serviceSelectors.getUpdatingMessages(state),
    filters : serviceSelectors.getChatFilters(state),
    filterListText : serviceSelectors.getChatFilterListText(state),
    filterSearch : serviceSelectors.getFilterSearch(state),
    filterDays : serviceSelectors.getFilterDays(state),
    filterAccountId : serviceSelectors.getFilterAccountId(state),
    activityViewType : serviceSelectors.getActivityViewType(state),
    pdfContent: serviceSelectors.getPdfContent(state),
    accountId: accountSelectors.getAccountId(state),
    blockNumbersAccount: serviceSelectors.getBlockNumbersByAccount(state),
    last20Messages: serviceSelectors.getLast20Messages(state),
    showLoading: serviceSelectors.getShowLoading(state),
    reportFiles: serviceSelectors.getReportFiles(state),
    startTime: serviceSelectors.getPureChatsStartTime(state),
    endTime: serviceSelectors.getPureChatsEndTime(state),
  });
};

const mapDispatchToProps = {
  setFilters: serviceActions.setChatFilters,
  setShowFilterDialog : serviceActions.setShowFilterDialog,
  setFilterType : serviceActions.setFilterType,
  setFilterSearch : serviceActions.setFilterSearch,
  setFilterDays : serviceActions.setFilterDays,
  setFilterAccountId : serviceActions.setFilterAccountId,
  setFilterLocationId : serviceActions.setFilterLocationId,
  openActivityDetail : serviceActions.openActivityDetail,
  updateMessages : serviceActions.updateMessages,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  toggleFollowup : serviceActions.toggleFollowup,
  setActivityViewType : serviceActions.setActivityViewType,
  clearHolds : serviceActions.clearHolds,
  setContactsSearchText : serviceActions.setContactsSearchText,
  newContact : serviceActions.newContact,
  openAssist : serviceActions.openAssist,
  manualTransfer : serviceActions.manualTransfer,
  generatePdf: serviceActions.generatePdfReport,
  generateCSV: serviceActions.generateCsvReport,
  blockPhoneNumber: serviceActions.blockPhoneNumber,
  unblockPhoneNumber: serviceActions.unblockPhoneNumber,
  getBlockNumbersByAccount:serviceActions.blockNumbersByAccount,
  downloadVoiceMail: serviceActions.downloadVoiceMail,
  bulkMarkMessageRead: serviceActions.bulkMarkMessageRead,
  bulkUnmarkMessageRead: serviceActions.bulkUnmarkMessageRead,
  bulkArchiveMessage: serviceActions.bulkArchiveMessage,
  bulkUnarchiveMessage: serviceActions.bulkUnarchiveMessage,
  toggleBulkFollowup: serviceActions.toggleBulkFollowup,
  updateFilters : serviceActions.updateFilters,
  getPureChats: serviceActions.getPureChats,
  markPurechatRead: serviceActions.markPurechatRead,
  markPurechatArchived: serviceActions.markPurechatArchived,
  markPurechatFollowup: serviceActions.markPurechatFollowup,
  postSnackMessage : coreActions.postSnackMessage,
  getReportFiles: serviceActions.getReportFiles,
  getSignedUrl: serviceActions.getSignedUrl,
  setPureChatStartTime: serviceActions.setPureChatStartTime,
  setPureChatEndTime: serviceActions.setPureChatEndTime,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChatActivity)));


